import classNames from 'classnames'
import * as React from 'react'

import { ApiUser } from '@aninix/api/helpers'
import { AninixRoleItem } from './aninix-role-item'
import { useCurrentRowContext } from './use-current-row-context'

interface IExpededRoles {
  role: ApiUser['aninixRole']
  isExpanded: boolean
  handleClose: (
    e: React.MouseEvent<HTMLDivElement, MouseEvent> | MouseEvent
  ) => void
}

export const ExpandedRoles: React.FCC<IExpededRoles> = ({
  role,
  isExpanded,
  handleClose,
}: IExpededRoles) => {
  const currentRowContext = useCurrentRowContext()

  React.useEffect(() => {
    currentRowContext?.rowRef?.current?.addEventListener(
      'mouseleave',
      handleClose
    )

    return () => {
      currentRowContext?.rowRef?.current?.removeEventListener(
        'mouseleave',
        handleClose
      )
    }
  })

  return (
    <div
      // onMouseLeave={handleClose}
      className={classNames(
        ' absolute z-[100] flex -translate-x-8 flex-col items-center overflow-clip rounded-md bg-white shadow-xl transition-all duration-300',
        {
          ['translate-y-6']: role == 'editor',
          ['-translate-y-6']: role == 'viewer',
          ['invisible opacity-0']: !isExpanded,
        }
      )}
    >
      {(['editor', 'viewer'] as const).map((r) => (
        <AninixRoleItem
          handleClose={handleClose}
          key={r.toString()}
          role={r}
          selectedRole={role}
        />
      ))}
    </div>
  )
}

ExpandedRoles.displayName = 'ExpandedRoles'
